import React, { useCallback } from 'react';
import { Radio, RadioChangeEvent, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as TranslateIcon } from '@assets/icons/translate.svg';
import { getAvailableLocales } from '../../i18n';

import * as S from './styles';

interface LanguageSelectorProps {
  className?: string;
}

const LanguageSelector = ({ className }: LanguageSelectorProps) => {
  const { i18n, t } = useTranslation('main');

  const onChange = useCallback(
    ({ target: { value } }: RadioChangeEvent) => {
      i18n.changeLanguage(value);
    },
    [i18n],
  );

  return (
    <S.LangSelectorContainer className={className}>
      <TranslateIcon />
      <Radio.Group onChange={onChange} value={i18n.language} size="small">
        {getAvailableLocales()?.map(value => (
          <Tooltip key={value} title={t(`languages.${value}`)}>
            <Radio.Button key={value} value={value}>
              {value?.toUpperCase()}
            </Radio.Button>
          </Tooltip>
        ))}
      </Radio.Group>
    </S.LangSelectorContainer>
  );
};

export default LanguageSelector;
